import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business インデックスルート。ダッシュボードへリダイレクト
 * @graph-connects none
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' }) as unknown as Error;
  },
});
